import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { log } from 'console';
import { Observable } from 'rxjs';

@Injectable({

  providedIn: 'root'
})
export class CsAdminGuard implements CanActivateChild {
  public userInfo: any = JSON.parse(localStorage.getItem("userInfo"));
  constructor(public router: Router) {

  }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    let obj = JSON.parse(localStorage.getItem("userInfo"));
    let memberType = obj.member_type;
    let orgAdmin = obj.org_admin;
    let role = obj.role;
    let superAdmin = obj.admin;
    let accessUrls = []
    
    if (memberType == "Client" && orgAdmin == true) {
      accessUrls = ['campaign_report','dashboard', 'new-client-project', 'users', 'project', 'rules', 'bookings', 'registration','tasks'];
    }
    else if (memberType == "Client" && orgAdmin == false) {
      accessUrls = ['project', 'registration', 'bookings', 'scheduler','tasks'];
    }
    else if (memberType == "Vendor" && orgAdmin == false && superAdmin == false && role != "SalesAdmin" && role != "FinanceAdmin" && role != "CreativeAdmin" && role != "BudgetManager") {
      accessUrls = ['comment-masters','dashboard-vendor', 'campaign-list','campaign-details', 'presale-master', 'project', 'leads', 'logs', 'scheduler','tasks'];
    }
    else if (memberType == "Vendor" && orgAdmin == true) {
      accessUrls = ['comment-masters','view_media_plan_request','media_plan','review-master','tasks','DRR-master', 'marketing-master', 'presale-master', 'creative-master', 'escalation-master', 'campaign-list','campaign-details', 'lead-report','near-by', 'edit-whatsapp-rule-entry', 'create-whatsapp-rule-entry', 'whatsapp-rule-entry', 'whatsapp-rules', 'dashboard-vendor', 'users', 'project', 'clients', 'leads', 'rules', 'logs', 'call-report', 'audience-recommendation-engine', 'stats-dashboard', 'reports-dashboard', 'project-wise-call-dashboard', 'telecaller-wise-call-dashboard', 'client-wise-lead-dashboard', 'project-wise-lead-dashboard','project-wise-source-dashboard'];
    }
    else if (memberType == "Vendor" && role == "SalesAdmin") {
      accessUrls = ['comment-masters','view_media_plan_request','media_plan','review-master','DRR-master', 'marketing-master', 'presale-master', 'creative-master', 'escalation-master', 'campaign-list','campaign-details', 'dashboard-vendor', 'project'];
    }
    else if(memberType == 'Vendor' && role == "FinanceAdmin"){
      accessUrls = ['comment-masters','review-master','DRR-master', 'marketing-master', 'presale-master', 'creative-master', 'escalation-master', 'campaign-list','campaign-details', 'dashboard-vendor','project'];
    }
    else if(memberType == 'Vendor' && role == "CreativeAdmin"){
      accessUrls = ['comment-masters','review-master','DRR-master', 'marketing-master', 'presale-master', 'creative-master', 'escalation-master', 'campaign-list','campaign-details','dashboard-vendor', 'project'];
    }    
    else if(memberType == 'Vendor' && role == "BudgetManager"){
      accessUrls = ['comment-masters','review-master','DRR-master', 'marketing-master', 'presale-master', 'creative-master', 'escalation-master', 'campaign-list','campaign-details', 'dashboard-vendor', 'project'];
    }    
    else if (superAdmin) {     
         accessUrls = ['comment-masters','view_media_plan_request','media_plan','review-master','DRR-master', 'marketing-master', 'presale-master', 'creative-master', 'escalation-master', 'campaign-list', 'campaign-details','lead-report','near-by', 'call-logs', 'dashboard-vendor', 'sales-account-create-modal', 'sales-account', 'users', 'project', 'vendors', 'clients', 'leads', 'campaign', 'logs', 'bookings', 'permission', 'policy', 'color', 'persona', 'audience-recommendation-engine', 'stats-dashboard', 'reports-dashboard', 'project-wise-call-dashboard', 'telecaller-wise-call-dashboard', 'client-wise-lead-dashboard', 'project-wise-lead-dashboard'];     
    }

    let presentUrl = childRoute.url[0].path;
    // console.log(presentUrl)
    if (memberType == "Vendor" && role == "SalesAdmin") {
      if (!accessUrls.includes(presentUrl)) {
        this.router.navigate(['/page/dashboard-vendor']);
      }
    }
    else {
      if (!accessUrls.includes(presentUrl)) {
        let dashboard = memberType == "Client" ? "dashboard" : "dashboard-vendor";
        orgAdmin ? this.router.navigate(['/page/' + dashboard]) : this.router.navigate(['/page/project']);
      }
    }
    return true;
  }
}